import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import '@shopify/polaris/build/esm/styles.css';
// After Polaris, so our overrides win on specificity ties. This used to be imported from
// pages/Invoices.jsx, which App pulls in on the line above the Polaris import — our rules
// were injected first and lost, which is why the ones below it carry !important.
import './style.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);